module.exports = require('./lib/axios');


//////////////////
// WEBPACK FOOTER
// ./~/_axios@0.16.2@axios/index.js
// module id = 196
// module chunks = 106